export default __webpack_public_path__ + "static/media/goalbase_navicon.48bf53b4.svg";